import unityVersion from '../unityVersion.json';
import { getSessionSetting } from './session';

export default function getUnityBundleVersion() {
  return (
    getSessionSetting('unity_version') || unityVersion.UNITY_BUNDLE_VERSION
  );
}
